// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

// Exposer Bootstrap globalement pour les contrôleurs Stimulus
window.bootstrap = bootstrap
